import type { ApiConfig } from '../../types'

export const depositHistoryApiConfig = {
  existSubType: true,
  fetchableRange: undefined,
  limit: 100,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'deposit-history',
} as const satisfies ApiConfig
